import dateFormatter from "../../../utils/dateFormatter";

export const PaymentLine = ({ payment }) => {
  return (
    <tr className="text-center">
      <td>{payment.amountPaid}</td>
      <td>{payment.paymentMethod}</td>
      <td>{dateFormatter(payment.createdAt)}</td>
      <td>{payment.receivedBy}</td>
      {/* <td>{item.quantity}</td>
      <td>{item.size ? item.size : 'N/A'}</td> */}
    </tr>
  );
};
